export default "__VITE_ASSET__Cldqj2Db__"